export type GuideFeatureIcon = 'target' | 'message' | 'layout' | 'timer' | 'sliders' | 'eye';

// Pairs: brown + orange, olive + cream, orange + brown — all readable icon combinations.
const BROWN = '#3A0E08';
const OLIVE = '#575F25';
const CREAM = '#FCF9EF';
const ORANGE = '#E36C20';
const NAVY = BROWN;
const GREEN = ORANGE;

export const guideFeatures: { label: string; text: string; icon: GuideFeatureIcon; bg: string; fg: string }[] = [
  {
    label: 'Goals & equipment',
    text: 'A clear goal for the lesson and the exact equipment to bring out.',
    icon: 'target',
    bg: NAVY,
    fg: GREEN,
  },
  {
    label: 'Instructions',
    text: 'Concrete, ready-to-say cues so you know what to tell the class.',
    icon: 'message',
    bg: OLIVE,
    fg: CREAM,
  },
  {
    label: 'Diagrams',
    text: 'Field and station diagrams that show where players, markers and targets go.',
    icon: 'layout',
    bg: NAVY,
    fg: GREEN,
  },
  {
    label: 'Timings',
    text: 'Every activity is timed to fit a 40-minute lesson from warm-up to close.',
    icon: 'timer',
    bg: ORANGE,
    fg: NAVY,
  },
  {
    label: 'Easier / harder',
    text: 'Simple options to adjust each activity for a mixed-level group.',
    icon: 'sliders',
    bg: OLIVE,
    fg: CREAM,
  },
  {
    label: 'Observation',
    text: 'What to watch for, so you can see who is ready to move on.',
    icon: 'eye',
    bg: NAVY,
    fg: GREEN,
  },
];

export const teachingSteps = [
  {
    title: 'Open the plan',
    text: 'Start with Lesson 1. Read the goal, equipment list and timings before class.',
  },
  {
    title: 'Set up the space',
    text: 'Follow the diagram to place markers, targets and groups before students arrive.',
  },
  {
    title: 'Teach and adapt',
    text: 'Use the instructions, switch to easier or harder options, and note what you observe.',
  },
];
